/** Info modal özet satırı (akordeon kapalı) */
export function accordionSummaryLabel(yetkiliAlt, bosAlt) {
  const y = Number(yetkiliAlt) || 0;
  const b = Number(bosAlt) || 0;
  if (y === 0 && b === 0) return '—';
  const parts = [];
  if (y > 0) parts.push(`${y} alt grup yetkili`);
  if (b > 0) parts.push(`${b} boş`);
  return parts.join(', ');
}

export function tekSatirLabel(grup) {
  if (!grup) return '—';
  if (grup.durum === 'bos') return 'Boş';
  if (grup.techService?.ad) return grup.techService.ad;
  return 'Kısmi yetki';
}
